// Define a class for the Swiper component that extends the HTMLElement class
class PromoBarComponent extends HTMLElement {
    // The constructor is called when an object is created with the class
    constructor() {
        super(); // Call the parent class constructor
    }

    // connectedCallback is a lifecycle method that is called when the custom element is first connected to the document's DOM
    connectedCallback() {
        this.initSwiper(); // Initialize the Swiper when the component is connected

        // Add event listeners
        document.addEventListener('shopify:section:load', this.initSwiper.bind(this));
        document.addEventListener('shopify:section:reorder', this.initSwiper.bind(this));
        document.addEventListener('shopify:section:select', this.initSwiper.bind(this));
        document.addEventListener('shopify:block:select', this.initSwiper.bind(this));
    }

    // Method to initialize the Swiper
    initSwiper() {
        // Get the data attributes
        const autoplayDelay = this.getAttribute('data-autoplay-delay') || 5000; // Default to 5000 if not set
        const sliderEffect = this.getAttribute('data-slider-effect') || 'fade'; // Default to 'fade' if not set

        // Define the options for the Swiper
        const swiperOptions = {
            slidesPerView: 1, // Number of slides per view
            centeredSlides: true, // Center the active slide
            loop: true, // Loop the slides
            autoplay: { // Autoplay options
                delay: parseInt(autoplayDelay), // Delay between slides in milliseconds
            },
            effect: sliderEffect, // Use the slider effect
            fadeEffect: { // Fade effect options
                crossFade: true // Enable cross-fade
            }
        };

        // Initialize the Swiper with the options
        new Swiper(this, swiperOptions);
    }
}

// Define the custom element
customElements.define("promo-bar", PromoBarComponent);